import React from 'react';
import {ReactComponent as ArrowBack} from  '../../../assets/icons/arrow_back.svg';
import {ReactComponent as CheckIcon} from '../../../assets/icons/check-blue.svg'

const MappingHeader = ({ onBack, title = "Mapping variants", activeStep }) => {
  return (
    <header className="mapping-header">
      <div className="header-left">
        <button className="back-button" onClick={onBack}>
          <ArrowBack />
          <span>Product detail</span>
        </button>
        <div className="divider-vertical"></div>
        <h1>{title}</h1>
      </div>

      <StepIndicator activeStep={activeStep} />
    </header>
  );
};

export const StepIndicator = ({ activeStep = 1 }) => {
  const steps = [
    { number: 1, title: 'Mapping variant' },
    { number: 2, title: 'Design variant' },
    { number: 3, title: 'Artwork' }
  ];

  return (
    <div className="header-steps">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={`step ${step.number === activeStep ? 'active' : ''} ${step.number < activeStep ? 'completed' : ''}`}>
            <div className="step-number">{
              step.number < activeStep ?
                <CheckIcon />
                : step.number}
            </div>
            <span className="step-title">{step.title}</span>
          </div>
          {index < steps.length - 1 && <div className={`step-connector ${step.number < activeStep ? 'completed' : ''}`}></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default MappingHeader;
